import React from 'react';
import './StoreEventFrame.css';

/**
 * StoreEventFrame: the Shopify page's hero visual (Oct 3 2026, Nitish ruled, Maeve built).
 * The employee's scheduled store check finds a new product, it drafts the listing and launch email,
 * waits for the owner's yes, then reports done. Pure CSS animation, ONE 12s duration for every
 * animated child (mixed durations drift); reduced motion shows the finished state as a still.
 * Every beat is something the employee can do through the owner's Shopify custom app (a scheduled
 * Admin API read, product writes, approval before anything customers see). Oct 16 2026: the event
 * trigger beat was removed; store-event triggers need the catalog connection, which is down (CEL-3488). Employee name "Sam" is neutral by ruling: never a
 * marketing-cast name (Alex / Studio Verla). Mock + QC: Maeve's work/shopify_frame/.
 */
const ASSETS = '/assets/ai-employees/for-shopify-stores';

const StoreEventFrame = () => (
  <div
    className="vlp-sf"
    role="img"
    aria-label="On their morning store check, an AI employee finds a new Shopify product, drafts the listing and launch email, and waits for the owner's approval before publishing."
  >
    <div className="vlp-sf__bar" aria-hidden="true">
      <span className="vlp-sf__dot" /><span className="vlp-sf__dot" /><span className="vlp-sf__dot" />
      <span className="vlp-sf__bartitle">Sam · Ember &amp; Wick store</span>
      <span className="vlp-sf__live"><i />Working</span>
    </div>
    <div className="vlp-sf__body" aria-hidden="true">
      <div className="vlp-sf__col">
        <div className="vlp-sf__label">Morning store check</div>
        <div className="vlp-sf__card vlp-sf__event sfa-event">
          <span className="vlp-sf__plate"><img src="https://logos.composio.dev/api/shopify" alt="" width="18" height="18" /></span>
          <div className="vlp-sf__ev-m"><b>New size found in Shopify</b><span>Lavender &amp; Cedar · new 16 oz</span></div>
          <img className="vlp-sf__thumb" src={`${ASSETS}/candle_sq.webp`} alt="" width="34" height="34" />
          <span className="vlp-sf__time">9:41</span>
        </div>
        <div className="vlp-sf__label">Sam&apos;s tasks</div>
        <div className="vlp-sf__card vlp-sf__task sfa-task">
          <span className="vlp-sf__t">Write the 16 oz listing and launch email</span>
          <span className="vlp-sf__chips">
            <span className="vlp-sf__chip vlp-sf__chip--prog sfa-prog">In progress</span>
            <span className="vlp-sf__chip vlp-sf__chip--done sfa-done">Done</span>
          </span>
        </div>
        <div className="vlp-sf__card vlp-sf__task">
          <span className="vlp-sf__t">Monday report: orders and repeat customers</span>
          <span className="vlp-sf__chip vlp-sf__chip--done">Done</span>
        </div>
        <div className="vlp-sf__report sfa-report">✓ Listing published · launch email sent</div>
      </div>
      <div className="vlp-sf__col">
        <div className="vlp-sf__card sfa-doc">
          <div className="vlp-sf__doc-h">Listing draft</div>
          <div className="vlp-sf__listing">
            <img className="vlp-sf__prod sfa-l1" src={`${ASSETS}/candle_sq.webp`} alt="" width="84" height="84" />
            <div>
              <div className="vlp-sf__doc-t">Lavender &amp; Cedar Candle, 16 oz</div>
              <p className="sfa-l2">The same blend, now in our largest jar. Hand-poured soy wax.</p>
              <div className="vlp-sf__price sfa-l3"><span>16 oz</span><b>$38.00</b></div>
            </div>
          </div>
        </div>
        <div className="vlp-sf__card sfa-mail">
          <div className="vlp-sf__doc-h">Launch email</div>
          <img className="vlp-sf__mail-img" src={`${ASSETS}/candle_wide.webp`} alt="" width="720" height="302" />
          <div className="vlp-sf__mail-s">Your favorite scent, now in 16 oz</div>
          <div className="vlp-sf__mail-p">Lavender &amp; Cedar has a bigger jar. Same pour, same calm, more evenings.</div>
        </div>
        <div className="vlp-sf__card vlp-sf__appr sfa-appr">
          <div className="vlp-sf__appr-h"><i />Waiting for your yes</div>
          <div className="vlp-sf__appr-q">Publish the listing and send the launch email?</div>
          <div className="vlp-sf__actions">
            <div className="vlp-sf__btns sfa-btns"><span className="vlp-sf__btn vlp-sf__btn--y sfa-press">Approve</span><span className="vlp-sf__btn">Edit</span></div>
            <div className="vlp-sf__approved sfa-approved">✓ Approved</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default StoreEventFrame;
